import { AuxBadgeStyleEnum, AuxBadgeWeightEnum } from "@blk/aladdin-web-components";
import { PageMargin, PageSize } from "components/workspaces/store/types";
import { language } from "language/default";
export const paperFormatValue = [
    { displayName: "A4", value: PageSize.A4 },
    { displayName: "A3", value: PageSize.A3 },
    { displayName: "Letter", value: PageSize.LETTER },
    { displayName: "Legal", value: PageSize.LEGAL }
];
export const paperFormatOptions = [
    { values: paperFormatValue.map((paperFormat) => ({
            displayValue: paperFormat.displayName,
            value: paperFormat.value
        })) }
];
export const marginValue = [
    { displayName: "5mm", value: PageMargin.M_5MM },
    { displayName: "10mm", value: PageMargin.M_10MM },
    { displayName: "15mm", value: PageMargin.M_15MM },
    { displayName: "20mm", value: PageMargin.M_20MM }
];
export const marginOptions = [
    { values: marginValue.map((margin) => ({
            displayValue: margin.displayName,
            value: margin.value
        })) }
];
export const printBadgeProps = {
    badgeStyle: AuxBadgeStyleEnum.NEUTRAL,
    value: language.en.dashboard.pdfExport.printLabel,
    weight: AuxBadgeWeightEnum.SUBTLE
};
